"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTapeBuilderRecordUI = exports.isTapeBuilderRecordDB = exports.isTapeBuilderRecordUI = exports.checkArtifact = exports.isTapeBuilderTask = exports.isTapeBuilderPreFilterTask = exports.isTapeBuilderSanitizeTask = exports.isTapeBuilderXlsx2CsvTask = void 0;
const zod_1 = require("zod");
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const tape_builder_1 = require("./types/tape-builder");
const OperationNodes = __importStar(require("./uiNodes/operations"));
const tasks_1 = require("./uiNodes/tasks");
const isTapeBuilderXlsx2CsvTask = (obj) => {
    return OperationNodes.Xlsx2Csv.TaskSchema.safeParse(obj).success;
};
exports.isTapeBuilderXlsx2CsvTask = isTapeBuilderXlsx2CsvTask;
const isTapeBuilderSanitizeTask = (obj) => {
    return OperationNodes.Sanitize.TaskSchema.safeParse(obj).success;
};
exports.isTapeBuilderSanitizeTask = isTapeBuilderSanitizeTask;
const isTapeBuilderPreFilterTask = (obj) => {
    return OperationNodes.PreFilter.TaskSchema.safeParse(obj).success;
};
exports.isTapeBuilderPreFilterTask = isTapeBuilderPreFilterTask;
const isTapeBuilderTask = (obj) => {
    // make a light check first to avoid heavy schema check
    if ('operation' in obj && typeof obj.operation === 'string') {
        return tasks_1.TapeBuilderTaskSchema.safeParse(obj).success;
    }
    return false;
};
exports.isTapeBuilderTask = isTapeBuilderTask;
const isArtifactType = (obj) => {
    return (typeof obj === 'string' && finley_types_1.DbTable.ArtifactTypeIterable.includes(obj));
};
const checkArtifact = ({ obj, artifactType: _unused, checkIntermediate, onError, }) => {
    const result = checkIntermediate
        ? tape_builder_1.TapeBuilderRecordUISchema.safeParse(obj)
        : tape_builder_1.TapeBuilderRecordDBSchema.safeParse(obj);
    if (!result.success) {
        (0, common_1.debugLog)('checkArtifact: validation failed:', zod_1.z.prettifyError(result.error));
        if (onError) {
            onError([zod_1.z.prettifyError(result.error)], obj);
        }
    }
    return result.success;
};
exports.checkArtifact = checkArtifact;
const isTapeBuilderRecordUI = (obj) => {
    if (!('type' in obj)) {
        (0, common_1.debugLog)('isTapeBuilderRecordUI: no type in obj:', obj);
        return false;
    }
    const artifactType = obj.type;
    if (!isArtifactType(artifactType)) {
        (0, common_1.debugLog)(`isTapeBuilderRecordUI: unknown artifactType:[${artifactType}]`, obj);
        return false;
    }
    return (0, exports.checkArtifact)({ obj, artifactType, checkIntermediate: true });
};
exports.isTapeBuilderRecordUI = isTapeBuilderRecordUI;
const isTapeBuilderRecordDB = (obj) => {
    if (!('type' in obj)) {
        (0, common_1.debugLog)('isTapeBuilderRecordDB: no type in obj:', obj);
        return false;
    }
    const artifactType = obj.type;
    if (!isArtifactType(artifactType)) {
        (0, common_1.debugLog)(`isTapeBuilderRecordUI: unknown artifactType:[${artifactType}]`, obj);
        return false;
    }
    return (0, exports.checkArtifact)({ obj, artifactType, checkIntermediate: false });
};
exports.isTapeBuilderRecordDB = isTapeBuilderRecordDB;
// This is not strictly a typeguard in the sense that it doesn't return a boolean.
const validateTapeBuilderRecordUI = (obj) => {
    if (!('type' in obj)) {
        (0, common_1.debugLog)('validateTapeBuilderRecordUI: no type in obj:', obj);
        return {
            isValid: false,
            errorMessages: ['validateTapeBuilderRecordUI: no type in obj:'],
        };
    }
    const artifactType = obj.type;
    if (!isArtifactType(artifactType)) {
        (0, common_1.debugLog)(`validateTapeBuilderRecordUI: unknown artifactType:[${artifactType}]`, obj);
        return {
            isValid: false,
            errorMessages: [
                `validateTapeBuilderRecordUI: unknown artifactType:[${artifactType}]`,
            ],
        };
    }
    const errorMessages = [];
    const onError = (errors, instance) => {
        (0, common_1.debugLog)(`Error validating schema for ${artifactType}`, errors, instance);
        errors.forEach((err) => {
            errorMessages.push(err);
        });
    };
    const isValid = (0, exports.checkArtifact)({
        obj,
        artifactType,
        checkIntermediate: true,
        onError,
    });
    return {
        isValid,
        errorMessages,
    };
};
exports.validateTapeBuilderRecordUI = validateTapeBuilderRecordUI;
//# sourceMappingURL=typeguards.js.map